<template>
    <main class="comparison-content" ref="pdfcontent">
        <div class="top-container">
            <h2>{{translate("product_comparison")}}</h2>
            <nav>
                <div class="calc_btn-container">
                    <!--                    <button @click="tryCalculate" class="btn-calculate">Przelicz</button>-->
                </div>
                <div v-for="(element, key) of getComparison.fans " class="fan_comparing-container">
                    <img :src='"data:image/png;base64, " + element.imgSrc'>
                    <div class="fan_info-container">
                        <span class="fan-name"><span class="to-lowercase" v-html="key == 0 ? getCounted(): getCountedOfFanToCompare()"></span>{{element.title}}</span>
                        <span class="fan-serial_number">{{element.serial_number}}</span>
                        <button v-if="key > 0" @click="deleteFan(key)" class="delete_fan-btn">{{translate("remove")}}</button>
                    </div>
                </div>
                <div v-if="getCompariseFansLength === 1" class="fan_comparing-container">
                    <div class="fan_info-container">
                        <span class="fan-name">{{translate("comparative_fan")}}</span>
                        <button @click="resetCustomComparison" class="delete_fan-btn">{{translate("reset")}}</button>
                    </div>
                </div>
            </nav>

            <div class="parameters-container">
                <div class="row" v-if="getComparison.fans && getComparison.fans.length > 0 && shouldDisplay(paramId)"
                     v-for="(param, paramId) in getComparison.fans[0].params">
                    <!--                  {{comparised_params[paramId] = 0}}-->

                    <div class="title">{{translate(param.title)}}
                        <span class="units units-const" v-html="getParamUnit(param.title)"></span>
                    </div>

                    <div class="column" v-for="(currentFan, currentFanId) in getComparison.fans">
                        {{currentFan.params[paramId].value}}
                    </div>

                    <!--                    <div class="column" v-if="getCompariseFansLength > 1 && getComparison.fans[1].param[id] !== undefined">-->
                    <!--                        {{getComparison.fans[1].param[id].value}}-->
                    <!--                    </div>-->
                    <div v-if="getCompariseFansLength === 1" class="column column-input"
                         :class="{'notValid':comparised_params[paramId]['notValid']}">
                        <input type="number" v-model="comparised_params[paramId].value"
                               @change="tryCalculate" min="0"
                               placeholder="-" title="">
                        <span class="pdf-visible-value">{{comparised_params[paramId].value}}</span>
                    </div>
                </div>
                <div class="row" v-for="(elem, index) of extra_param">
                    <div class="title">
                        <span class="info-box" v-if="elem.desc">{{translate(elem.desc)}}</span>
                        <span>{{translate(elem.title)}}</span>
                        <span v-if="elem.unit" class="units units-const" v-html="translate(elem.unit)">
                        </span>
                        <div class="value_with_select-container" v-else-if="elem.units">
                            <div class="custom-select">
                                <div class="selected_item">
                                <span class="value"
                                      v-html="selectedCurrency"></span>
                                    <span class="icon-bottom_arrow"></span>
                                </div>
                                <div class="items-container">
                                    <div class="item"
                                         v-for="(element, element_id) in elem.units"
                                         @click="selectCurrency(element.value)">
                                        <span>{{element.value}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column column-input column-single-input">
                        <template v-if="elem.min && elem.max">
                            <input v-model="extra_param[index]['value']" v-bind:placeholder="translate('enter_value')" type="number"
                                   @change="tryCalculate" :min="elem.min" :max="elem.max" step="0.5">
                            <span class="pdf-visible-value">{{extra_param[index]['value']}}</span>
                        </template>
                        <template v-else>
                            <input v-model="extra_param[index]['value']" type="number" v-bind:placeholder="translate('enter_value')"
                                   min="0" step="0.1"
                                   @change="tryCalculate">
                            <span class="pdf-visible-value">{{extra_param[index]['value']}}</span>
                        </template>
                    </div>
                </div>
            </div>

            <transition name="fade">
                <div v-if="isVisible" class="visible-tables">
                    <div class="on-without-material-table"
                         v-if="(getComparison.fans[0].params.power_on_shaft.value !== getComparison.fans[0].params.power_on_shaft_with_material.value) || (comparised_params.power_on_shaft_with_material.value !== comparised_params.power_on_shaft.value)">
                        <h2>{{translate("with_material")}}</h2>
                        <div class="row fan-headers">
                            <span v-for="(element, key) of this.$store.state.comparison.fans">{{element.title+' '+element.serial_number}}</span>
                            <span v-if="getCompariseFansLength === 1">{{translate("comparative_fan")}}</span>
                            <span>{{ translate('difference') }}</span>
                        </div>
                        <div class="row" v-for="(param, paramId) in getFanMaterialsComparison.with_materials[0].params">
                            <div class="title">
                                {{translate(param.title)}}
                            </div>
                            <div class="column column-units">
                                <span v-html="getParamUnit('power')+'h'"></span>
                                <span>{{selectedCurrency}}</span>
                            </div>
                            <div class="column column-units">
                                <span>{{(compareResults.withMaterial[0].demand*factors[paramId]).toFixed(1)}}</span>
                                <span>{{(compareResults.withMaterial[0].price*factors[paramId]).toFixed(2)}}</span>
                            </div>
                            <div class="column column-units">
                                <span v-if="!customParamsNull">{{(compareResults.withMaterial[1].demand*factors[paramId]).toFixed(1)}}</span>
                                <span v-else>-</span>
                                <span v-if="!customParamsNull">{{(compareResults.withMaterial[1].price*factors[paramId]).toFixed(2)}}</span>
                                <span v-else>-</span>
                            </div>
                            <div class="column column-units">
                                <span v-if="!customParamsNull">{{Math.abs((compareResults.withMaterial[0].demand*factors[paramId])-parseFloat(compareResults.withMaterial[1].demand*factors[paramId])).toFixed(1)}}</span>
                                <span v-else>-</span>
                                <span v-if="!customParamsNull">{{Math.abs((compareResults.withMaterial[0].price*factors[paramId])-parseFloat(compareResults.withMaterial[1].price*factors[paramId])).toFixed(2)}}</span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                    <div class="on-without-material-table">
                        <h2>{{translate("without_material")}}</h2>
                        <div class="row fan-headers">
                            <span v-for="(element, key) of this.$store.state.comparison.fans">{{element.title+' '+element.serial_number}}</span>
                            <span v-if="getCompariseFansLength === 1">{{translate("comparative_fan")}}</span>
                            <span>{{ translate('difference') }}</span>
                        </div>
                        <div class="row"
                             v-for="(param, paramId) in getFanMaterialsComparison.without_materials[0].params">
                            <div class="title">
                                {{translate(param.title)}}
                            </div>
                            <div class="column column-units">
                                <span v-html="getParamUnit('power')+'h'"></span>
                                <span>{{selectedCurrency}}</span>
                            </div>
                            <div class="column column-units">
                                <span>{{(compareResults.withoutMaterial[0].demand*factors[paramId]).toFixed(1)}}</span>
                                <span>{{(compareResults.withoutMaterial[0].price*factors[paramId]).toFixed(2)}}</span>
                            </div>
                            <div class="column column-units">
                                <span v-if="!customParamsNull">{{(compareResults.withoutMaterial[1].demand*factors[paramId]).toFixed(1)}}</span>
                                <span v-else>-</span>
                                <span v-if="!customParamsNull">{{(compareResults.withoutMaterial[1].price*factors[paramId]).toFixed(2)}}</span>
                                <span v-else>-</span>
                            </div>
                            <div class="column column-units">
                                <span v-if="!customParamsNull">{{Math.abs((compareResults.withoutMaterial[0].demand*factors[paramId])-parseFloat(compareResults.withoutMaterial[1].demand*factors[paramId])).toFixed(1)}}</span>
                                <span v-else>-</span>
                                <span v-if="!customParamsNull">{{Math.abs((compareResults.withoutMaterial[0].price*factors[paramId])-parseFloat(compareResults.withoutMaterial[1].price*factors[paramId])).toFixed(2)}}</span>
                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="navi-btn">
                <router-link to="/" tag="button" class="back-btn"><span>{{translate("back_btn")}}</span></router-link>
                <button v-if="isVisible" class="pdf-btn" @click="generatePDF">
                    <InlineLoader v-if="pdfInAction"/>
                    <template v-else>
                        {{translate("print_to_pdf")}}
                    </template>
                </button>
            </div>
        </div>
    </main>
</template>

<script>

    import {fanObjParamsManager} from "../fanObjParamsManager";

    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    import Vue from 'vue';
    import jsPdf from 'jspdf';
    import html2canvas from 'html2canvas';
    import InlineLoader from "../components/InlineLoader";

    export default {
        name: "FanComparison",
        components: {InlineLoader},
        data() {
            return {
                value: '',
                isCompared: true,
                factors: {
                    day: 1,
                    month: 30,
                    year: 365
                },
                pdfInAction: false,
                customParamsNull: true,
                isVisible: false,
                comparised_params: [],
                selectedCurrency: 'EUR',
                extra_param: {
                    time: {
                        title: 'shift_work',
                        unit: 'shift',
                        desc: 'shift_equals',
                        min: 1,
                        max: 3,
                        value: ''
                    },
                    avgCost: {
                        title: 'average_cost_for',
                        units: [
                            {
                                value: 'PLN',
                                active: false,
                            },
                            {
                                value: "EUR",
                                active: true
                            }
                        ],
                        value: ''
                    }
                },
                compareResults: {
                    withMaterial: [
                        {
                            day: {
                                demand: 0,
                                price: 0
                            }
                        },
                        {
                            day: {
                                demand: 0,
                                price: 0
                            }
                        }
                    ],
                    withoutMaterial: [
                        {
                            day: {
                                demand: 0,
                                price: 0
                            }
                        },
                        {
                            day: {
                                demand: 0,
                                price: 0
                            }
                        }
                    ],
                }
            }
        },
        methods: {

            getCounted(){
                if(this.$store.state.workPointParameters.elements.number_of_fans && this.$store.state.workPointParameters.elements.number_of_fans.value > 1) {
                    return this.$store.state.workPointParameters.elements.number_of_fans.value + "x&nbsp";
                } else {
                    return "";
                }
            },

            getCountedOfFanToCompare() {
             if(this.$store.state.fanToCompare && this.$store.state.fanToCompare.data && this.$store.state.fanToCompare.data.number_of_fans > 1 ) {
                return this.$store.state.fanToCompare.data.number_of_fans  + "x&nbsp";
             } else {
                 return "";
             }
            },

            getRandomNumber(min, max) {
                return Math.random() * (max - min) + min;
            },

            generatePDF() {
                if(this.pdfInAction) return;
                this.pdfInAction = true;
                let content = document.body.outerHTML;
                let data = new FormData();
                data.append('content', content);
                data.append('id_offer_temp', `fan_comparison_${this.getRandomNumber(10000000, 99999999)}`);
                this.$apiController.getSinglePdf(data)
                    .then((res) => {
                        if (res.status === 'success') {
                            const linkSource = `data:application/pdf;base64,${res.data.file}`;
                            const downloadLink = document.createElement("a");
                            let fileName = `${this.getComparison.fans[0].serial_number.replace(/\//gi,'-')}_comparison.pdf`;

                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            this.$notifications.add(this.$notifications.TYPES.NOTIFICATION, 'PDF', this.translate('pdf_generate_success'));
                        } else {
                            this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                        }
                    })
                    .catch((e) => {
                        this.$notifications.add(this.$notifications.TYPES.ERROR, 'PDF', this.translate('pdf_generate_fail'));
                    })
                    .finally(()=>{
                        this.pdfInAction = false;
                    });

            },

            selectCurrency(currency) {
                this.selectedCurrency = currency;
            },

            resetCustomComparison() {
                for (let param in this.comparised_params) {
                    if (this.comparised_params.hasOwnProperty(param)) {
                        Vue.set(this.comparised_params[param], 'value', '');
                        Vue.set(this.comparised_params[param], 'notValid', false);
                        this.customParamsNull = true;
                    }
                }
                this.tryCalculate();
            },

            validate(target = null) {

                let workTime = parseFloat(this.extra_param.time.value);
                let averageCost = parseFloat(this.extra_param.avgCost.value);

                function checkWorkTime() {
                    if (workTime < 1 || workTime > 3) {
                        this.$store.commit('removeAllNotifications');
                        this.$notifications.add(this.$notifications.TYPES.WARNING, this.translate('incorrect_value'), this.translate('choose_hour_range_from_1_to_3'));
                        return false;
                    } else if (this.extra_param.time.value === '') {
                        return false;
                    }
                    return true;
                }

                function checkAverageCost() {
                    if (averageCost < 0) {
                        this.$store.commit('removeAllNotifications');
                        this.$notifications.add(this.$notifications.TYPES.WARNING, this.translate('incorrect_value'), this.translate('positive_cost'));
                        return false;
                    } else if (this.extra_param.avgCost.value === '') {
                        return false;
                    }
                    return true;
                }

                function checkCustomCompared() {
                    if (this.getCompariseFansLength !== 1) {
                        this.customParamsNull = false;
                        return true;
                    }

                    let sum = 0;
                    let parametersCounter = 0;
                    let correctParameters = 0;
                    let filledParameters = 0;

                    for (let parameter in this.comparised_params) {
                        if (this.comparised_params.hasOwnProperty(parameter)) {

                            sum += this.comparised_params[parameter].value;
                            parametersCounter++;

                            this.comparised_params[parameter].notValid = false;

                            if (this.comparised_params[parameter].value !== '') {
                                filledParameters++;
                            }

                            if (isNumber(this.comparised_params[parameter].value) && parseFloat(this.comparised_params[parameter].value) > 0) {
                                correctParameters++;
                            } else this.comparised_params[parameter].notValid = true;
                        }
                    }

                    if (filledParameters === 0) {
                        for (let parameter in this.comparised_params) {
                            if (this.comparised_params.hasOwnProperty(parameter)) {
                                this.comparised_params[parameter].notValid = false;
                            }
                        }

                        this.customParamsNull = true;

                        return true;
                    } else {
                        for (let parameter in this.comparised_params) {
                            if (this.comparised_params.hasOwnProperty(parameter)) {
                                if(this.comparised_params[parameter] === '') {
                                    this.comparised_params[parameter].notValid = true;
                                }
                            }
                        }
                    }

                    if (sum == 0) {
                        this.customParamsNull = true;
                        return true;
                    }

                    if (filledParameters !== parametersCounter)
                        return false;

                    if (correctParameters === parametersCounter) {
                        this.customParamsNull = false;
                        return true;
                    }

                    return false;

                }

                if (target === 'workTime') {
                    return checkWorkTime.call(this);
                }

                if (target === 'averageCost') {
                    return checkAverageCost.call(this);
                }

                if (target === null) {
                    return checkCustomCompared.call(this) === true && checkWorkTime.call(this) === true && checkAverageCost.call(this) === true;
                }

            },

            calcUnit(key, value) {

                if (value == "nieobliczalne" || value == "+nieskończoność" || value == "-nieskończoność")
                    return "-";

                if (!this.$store.state.ValueUnitMap[key] || !this.$store.state.ValueUnitMap[key].value != "" || !this.$store.state.ValueUnitMap[key].selected)
                    return value;

                let param = {value: value};
                let option = {elements: {1: this.$store.state.ValueUnitMap[key].selected}};

                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
            shouldDisplay(paramId) {
                let shoulddisplay = false;

                if (this.getComparison.fans && this.getComparison.fans.length > 1) {
                    for (let fan of this.getComparison.fans) {
                        if (!fan.params[paramId].hasOwnProperty("connected") || !fan.params[fan.params[paramId].connected] || fan.params[fan.params[paramId].connected].value != fan.params[paramId].value)
                            shoulddisplay = true;
                    }
                } else {
                    shoulddisplay = true;
                }

                return shoulddisplay;
            },

            tryCalculate() {
                if (this.validate()) {

                    this.isVisible = true;
                    let i = 0;
                    for (let fan of this.$store.state.comparison.fans) {
                        let powerOnShaft = fan.params.power_on_shaft.originalValue;
                        let powerOnShaftWithMaterial = fan.params.power_on_shaft_with_material.originalValue;
                        let efficiency = fan.params.engine_efficiency.originalValue;


                        let param = {value: powerOnShaft};
                        let option = {elements: {1: this.$store.state.ValueUnitMap['power'].selected}};

                        let tmpRound = {
                            type: 'roundValue',
                            elements: option.elements,
                            value: powerOnShaft,
                            out: ""
                        }

                        this.$store.commit("roundValue", tmpRound);

                        let tmpPayload = {
                            type: 'calcRestoreUnit',
                            param: param,
                            option: option,
                            value: tmpRound.out,
                            out: ""
                        }
                        this.$store.commit("calcRestoreUnit", tmpPayload);
                        powerOnShaft = parseFloat(tmpPayload.out);

                        param = {value: powerOnShaftWithMaterial};
                        option = {elements: {1: this.$store.state.ValueUnitMap['power'].selected}};

                        tmpRound = {
                            type: 'roundValue',
                            elements: option.elements,
                            value: powerOnShaftWithMaterial,
                            out: ""
                        }

                        this.$store.commit("roundValue", tmpRound);

                        tmpPayload = {
                            type: 'calcRestoreUnit',
                            param: param,
                            option: option,
                            value: tmpRound.out,
                            out: ""
                        }
                        this.$store.commit("calcRestoreUnit", tmpPayload);
                        powerOnShaftWithMaterial = parseFloat(tmpPayload.out);

                        let demandWithMaterial = 0;
                        let demandWithoutMaterial = 0;

                        demandWithMaterial = powerOnShaftWithMaterial / efficiency * parseFloat(this.extra_param.time.value) * 8;

                        Vue.set(this.compareResults.withMaterial[i], 'demand', this.calcUnit('power', demandWithMaterial));
                        Vue.set(this.compareResults.withMaterial[i], 'price', demandWithMaterial * parseFloat(this.extra_param.avgCost.value));

                        demandWithoutMaterial = powerOnShaft / efficiency * parseFloat(this.extra_param.time.value) * 8;

                        Vue.set(this.compareResults.withoutMaterial[i], 'demand', this.calcUnit('power', demandWithoutMaterial));
                        Vue.set(this.compareResults.withoutMaterial[i], 'price', demandWithoutMaterial * parseFloat(this.extra_param.avgCost.value));

                        i++;
                    }
                    if (this.getCompariseFansLength === 1) {
                        let powerOnShaft = parseFloat(this.comparised_params['power_on_shaft'].value);
                        let powerOnShaftWithMaterial = parseFloat(this.comparised_params['power_on_shaft_with_material'].value);
                        let efficiency = parseFloat(this.comparised_params['engine_efficiency'].value);


                        let param = {value: powerOnShaft};
                        let option = {elements: {1: this.$store.state.ValueUnitMap['power'].selected}};

                        let tmpPayload = {
                            type: 'calcRestoreUnit',
                            param: param,
                            option: option,
                            value: powerOnShaft,
                            out: ""
                        };

                        this.$store.commit("calcRestoreUnit", tmpPayload);

                        let originalPowerOnShaft = parseFloat(tmpPayload.out);

                        tmpPayload.param.value = efficiency;
                        tmpPayload.value = efficiency;
                        tmpPayload.option = {elements: {1: this.$store.state.ValueUnitMap['engine_efficiency'].selected}};
                        this.$store.commit("calcRestoreUnit", tmpPayload);
                        let originalEfficiency = parseFloat(tmpPayload.out);

                        tmpPayload.param.value = powerOnShaft;
                        tmpPayload.value = powerOnShaftWithMaterial;
                        tmpPayload.option = {elements: {1: this.$store.state.ValueUnitMap['power'].selected}};

                        this.$store.commit("calcRestoreUnit", tmpPayload);

                        let originalPowerOnShaftWithMaterial = parseFloat(tmpPayload.out);

                        let demandWithMaterial = 0;
                        let demandWithoutMaterial = 0;

                        this.compareResults.withMaterial[1].demand = 0;
                        this.compareResults.withMaterial[1].price = 0;

                        this.compareResults.withoutMaterial[1].demand = 0;
                        this.compareResults.withoutMaterial[1].price = 0;

                        demandWithMaterial = originalPowerOnShaftWithMaterial / originalEfficiency * parseFloat(this.extra_param.time.value) * 8;
                        Vue.set(this.compareResults.withMaterial[1], 'demand', this.calcUnit('power', demandWithMaterial));
                        Vue.set(this.compareResults.withMaterial[1], 'price', demandWithMaterial * parseFloat(this.extra_param.avgCost.value));

                        demandWithoutMaterial = originalPowerOnShaft / originalEfficiency * parseFloat(this.extra_param.time.value) * 8;
                        Vue.set(this.compareResults.withoutMaterial[1], 'demand', this.calcUnit('power', demandWithoutMaterial));
                        Vue.set(this.compareResults.withoutMaterial[1], 'price', demandWithoutMaterial * parseFloat(this.extra_param.avgCost.value));

                    }
                } else {
                    this.isVisible = false;
                }
                this.$forceUpdate();
            },

            deleteFan(id) {
                this.$store.state.comparison.fans.splice(id, 1);
                this.customParamsNull = true;
            },

            prepareCustomModel() {
                if (this.getComparison.fans && this.getComparison.fans.length > 0) {
                    for (let paramId in this.getComparison.fans[0].params) {
                        if (this.getComparison.fans[0].params.hasOwnProperty(paramId)) {
                            this.comparised_params[paramId] = {title: paramId, value: ''};
                        }
                    }
                }
            },
            getMainFanInfo() {
                let fan = {
                    imgSrc: this.$store.state.activeFun.src,
                    title: this.$store.state.activeFun.type,
                    serial_number: this.$store.state.activeFun.model,
                    params: {},
                };

                fan.params["performance"] = {
                    title: "performance",
                    value: parseFloat(this.calcUnit("performance", this.$store.state.workPointParameters.elements['performance'].value)),
                    originalValue: this.$store.state.workPointParameters.elements['performance'].value
                };

                let pressureType = this.$fanObjParamsManager.getPressureType(this.$store);
                fan.params[pressureType + "_pressure"] = {
                    title: pressureType + "_pressure",
                    value: parseFloat(this.calcUnit(pressureType + "_pressure", this.$store.state.workPointParameters.elements[pressureType + "_pressure"].value)),
                    originalValue: this.$store.state.workPointParameters.elements[pressureType + "_pressure"].value
                };

                fan.params["power_on_shaft"] = {
                    title: "power_on_shaft",
                    value: parseFloat(this.calcUnit("power_on_shaft", this.$store.state.workPointParameters.elements['power_on_shaft'].value)),
                    originalValue: this.$store.state.workPointParameters.elements['power_on_shaft'].value
                };
                fan.params["power_on_shaft_with_material"] = {
                    title: "power_on_shaft_with_material",
                    connected: "power_on_shaft",
                    value: parseFloat(this.calcUnit("power_on_shaft_with_material", this.$store.state.workPointParameters.elements['power_on_shaft_with_material'].value)),
                    originalValue: this.$store.state.workPointParameters.elements['power_on_shaft_with_material'].value
                };

                fan.params["engine_efficiency"] = {
                    title: "engine_efficiency",
                    value: parseFloat(this.calcUnit("efficiency", this.$store.state.activeFun.params['engine_efficiency'])),
                    originalValue: this.$store.state.activeFun.params['engine_efficiency']
                };

                return fan;
            },
            getFanToCompare() {
                let fan = {
                    imgSrc: this.$store.state.fanToCompare.src,
                    title: this.$store.state.fanToCompare.type,
                    serial_number: this.$store.state.fanToCompare.model,
                    params: {},
                };

                let pressureType = this.$fanObjParamsManager.getPressureType(this.$store);
                let frequency = this.$fanObjParamsManager.getNetwork_frequency(this.$store);
                let performanceTmp = this.$store.state.fourthStepParametersSelected.performance.value / ( this.$store.state.fanToCompare.data.number_of_fans);
                let performanceHourTmp = performanceTmp * 3600;
                let measurements = this.$calculator.MakeMeasurement(this.$store, this.$store.state.fanToCompare.data.id, frequency, pressureType, performanceTmp, performanceHourTmp);

                fan.params["performance"] = {
                    title: "performance",
                    value: parseFloat(this.calcUnit("performance", this.$store.state.fanToCompare.params['performance'])),
                    originalValue: this.$store.state.fanToCompare.params['performance']
                };
                fan.params[pressureType + "_pressure"] = {
                    title: pressureType + "_pressure",
                    value: parseFloat(this.calcUnit(pressureType + "_pressure", this.$store.state.fanToCompare.params[pressureType + "_pressure"])),
                    originalValue: this.$store.state.fanToCompare.params[pressureType + "_pressure"]
                };

                fan.params["power_on_shaft"] = {
                    title: "power_on_shaft",
                    value: parseFloat(this.calcUnit("power_on_shaft", measurements.graphsObj.workPointResult.PowerOnShaft._oryginal * this.$store.state.fanToCompare.data.number_of_fans)),
                    originalValue: measurements.graphsObj.workPointResult.PowerOnShaft._oryginal * this.$store.state.fanToCompare.data.number_of_fans
                };
                fan.params["power_on_shaft_with_material"] = {
                    title: "power_on_shaft_with_material",
                    connected: "power_on_shaft",
                    value: parseFloat(this.calcUnit("power_on_shaft_with_material", measurements.graphsObj.workPointResult.PowerOnShaftWithMaterial._oryginal * this.$store.state.fanToCompare.data.number_of_fans)),
                    originalValue: measurements.graphsObj.workPointResult.PowerOnShaftWithMaterial._oryginal * this.$store.state.fanToCompare.data.number_of_fans
                };

                fan.params["engine_efficiency"] = {
                    title: "engine_efficiency",
                    value: parseFloat(this.calcUnit("efficiency", this.$store.state.fanToCompare.params['engine_efficiency'])),
                    originalValue: this.$store.state.fanToCompare.params['engine_efficiency']
                };

                return fan;
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
            toggleExpandOfCustomSelect(e) {

                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },
        },

        computed: {
            getComparison() {
                return this.$store.state.comparison;
            },

            getFanMaterialsComparison() {
                return this.$store.state.fanMaterials;
            },

            getCompariseFansLength() {
                return Object.keys(this.getComparison.fans).length;
            },
            getParamUnit() {
                return function (key) {
                    if (this.$store.state.ValueUnitMap[key] && this.$store.state.ValueUnitMap[key].value != "" && this.$store.state.ValueUnitMap[key].selected && this.$store.state.ValueUnitMap[key].selected.value)
                        return this.$store.state.ValueUnitMap[key].selected.value;
                    else
                        return '';
                }
            }
        },

        beforeMount() {
            this.$store.state.comparison.fans.length = 0;

            if (this.$store.state.selectedFan)
                this.$store.state.comparison.fans.push(this.getMainFanInfo());

            if (this.$store.state.fanToCompare.data != null && this.$store.state.fanToCompare.id != this.$store.state.activeFun.id)
                this.$store.state.comparison.fans.push(this.getFanToCompare());

            this.prepareCustomModel();
        },

        mounted() {
            document.addEventListener("click", this.toggleExpandOfCustomSelect);
        },

        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        }

    }
</script>

<style scoped lang="scss">
    .fade-enter, .fade-leave-to {
        opacity: 0;
        padding-bottom: 0;
    }
</style>